<ng-container *ngIf="currentStep$ | async as currentStep">
  <div class="container">
    <h1
      class="h2 py-1 py-lg-2 fw-bold text-center"
      i18n
      *ngIf="currentStep === 1"
    >
      Online appointment booking
    </h1>
    <h1
      class="text-center h2 py-1 py-lg-2 fw-bold"
      i18n
      *ngIf="currentStep === 2 || currentStep === 3"
    >
      Online appointment
    </h1>
    <app-steps [currentStep]="currentStep$ | async" [steps]="steps"></app-steps>
  </div>
  <div class="container-background mb-5">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
